'use client'

import classNames from 'classnames'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useBoolean } from 'react-use'

export default function ToggleBox({
  height,
  children,
  showAllLabel = <button className='button-text-primary'>Show all <i className='icon icon-arrow-down !text-sm'></i></button>,
  showLessLabel = <button className='button-text-primary'>Show less <i className='icon icon-arrow-up !text-sm'></i></button>,
  className
}) {

  const containerRef = useRef()
  const [containerHeight, setHeight] = useState(height)
  const [display, toggleDisplay] = useBoolean(false)
  const [displayBtn, toggleBtn] = useBoolean(true)
  const style = useMemo(() => {
    return display ? { height: containerHeight } : { height: Math.min(containerHeight, height) }
  }, [display, containerHeight, height])

  useEffect(() => {
    if (!containerRef.current) return
    setHeight(containerRef.current.offsetHeight)
  }, [containerRef, display])

  useEffect(() => {
    if (height > containerHeight) {
      toggleDisplay(true)
      toggleBtn(false)
    }
  }, [containerHeight, height, toggleDisplay, toggleBtn])

  return (
    <>
      <div style={style} className={classNames('overflow-hidden transition-[height] relative', className)}>
        <div ref={containerRef}>
          {children}
        </div>
        {!display && <div className='absolute inset-x-0 bottom-0 min-h-[80px] bg-gradient-to-b from-[rgba(255,255,255,0.2)] to-white'></div>}
      </div>
      {
        displayBtn && (
          <div className='mt-10'>
            <div className='inline-block' onClick={() => toggleDisplay()}>{display ? showLessLabel : showAllLabel}</div>
          </div>
        )
      }
    </>
  )
}